export const BUILD_INFO = {
  version: '1.0.4',
  target: 'Cloudflare Pages',
  commitHash: '28a0d18',
  buildTag: 'cf-pages-prod',
  buildDate: '2026-07-29',
};
